var _circle, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#F0F3F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 5.625,
    width: 1.5,
    height: 6,
    rx: 0.75,
    fill: "#3F8CFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 3.375,
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    fill: "#3F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.25113e02cee99d4df48926ed34d8f8ee.svg";
export { ForwardRef as ReactComponent };